import { WIDGET_SIZES, WIDGET_TYPES } from 'components/global/ManageWidgetsModal';

export const analysisChartsConfigRaw = {
	'/analysis/overview_new': [
		{
			id: 'analysis.overview',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.large
		},
		{
			id: 'analysis.pendingShipments',
			type: WIDGET_TYPES.table,
			size: WIDGET_SIZES.large
		}
	],
	'/analysis/sla-performance_new': [
		{
			id: 'analysis.sla.delay',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large
		},
		{
			id: 'preparationSLAPerformance',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.large
		},
		{
			id: 'pickupSLAPerformance',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.large
		},
		{
			id: 'deliverySLAPerformance',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.large
		}
	],
	'/analysis/delivery-company_new': [
		{
			id: 'dcPerformance',
			type: WIDGET_TYPES.table,
			size: WIDGET_SIZES.large
		},
		{
			id: 'deliveryCompDistribution',
			type: WIDGET_TYPES.bar,
			size: WIDGET_SIZES.large,
			infoMessage: 'widgets.overview.deliveryCompDistribution.infoMessage'
		}
	],
	'/analysis/shipping-accounting_new': [
		{
			id: 'shippingAccountingSummary',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large
		},
		{
			id: 'otoShippingPartners',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.large
		},
		{
			id: 'yourShippingPartners',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.large
		}
	],
	'/analysis/sales_new': [
		{
			id: 'orderValuesSummary',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large,
			infoMessage: 'widgets.sales.orderValuesSummary.infoMessage'
		},
		{
			id: 'shipmentPaymentType',
			type: WIDGET_TYPES.pie,
			// for resizing feature
			// size: WIDGET_SIZES.medium
			size: WIDGET_SIZES.small
		},
		{
			id: 'ordersByCity',
			type: WIDGET_TYPES.pie,
			// for resizing feature
			// size: WIDGET_SIZES.medium
			size: WIDGET_SIZES.small
		},
		{
			id: 'numberOfOrders',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.large,
			infoMessage: 'widgets.sales.numberOfOrders.infoMessage'
		},
		{
			id: 'avgBasketSize',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.large
		}
	],
	'/analysis/customer-details_new': [
		{
			id: 'customerSummary',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large
		},
		{
			id: 'analysis.customerOrdersDescription',
			type: WIDGET_TYPES.table,
			size: WIDGET_SIZES.large
		}
	],
	'/analysis/oto-flex_new': [
		{
			id: 'orderValuesSummary',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large,
			infoMessage: 'widgets.oto-flex.orderValuesSummary.infoMessage'
		},
		{
			id: 'numberOfOrders',
			type: WIDGET_TYPES.line,
			size: WIDGET_SIZES.large,
			infoMessage: 'widgets.oto-flex.numberOfOrders.infoMessage'
		},
		{
			id: 'driverPerformance',
			type: WIDGET_TYPES.table,
			size: WIDGET_SIZES.large
		}
	],
	'/analysis/otopack_new': [
		{
			id: 'inboundStatistics',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large
		},
		{
			id: 'pickStatistics',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large
		},
		{
			id: 'packStatistics',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large
		},
		{
			id: 'returnStatistics',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large
		}
	]
};

export const chartsConfig = (rawSource) =>
	Object.keys(rawSource).reduce((acc, key) => {
		acc[key] = rawSource[key].map((chart) => {
			chart.order = 0;
			if (chart.isVisible === undefined) {
				chart.isVisible = true;
			}
			chart.name = `${chart.id}`;
			if (chart.infoMessage === undefined) {
				chart.infoMessage = `widgets.${chart.id}.infoMessage`;
			}
			return chart;
		});
		return acc;
	}, {});
